import axios from "axios";
//const apibaseurl='https://viivapi.trigma.ai/';
const apibaseurl='https://uat-mmm-api.trigma.ai/';
const macaddress= '10.18.2.121';
const Api = axios.create({
    baseURL: apibaseurl,
    params: {
        auth_key:'4549A1EA-9C0D-43A1-98E7-F2B5D13095DC',
        mac_address:macaddress,
        uid:1,
        appid:4,
        token:'test23062022'
      }
});
/*
const Api = axios.create({
    baseURL: 'http://Mmmplatformapi-env.eba-dtpwwm2u.ap-south-1.elasticbeanstalk.com/',
    headers:{
        'X-Requested-With': 'XMLHttpRequest1234'            
       
      },
      Authorization: {
        username: 'foo',
        password: 'baz',
        mytest:'df#dju89JKL'
      
      },
      params:{
        client_ip: 'foo',
        auth_key: 'baz',
        mac_address:'df#dju89JKL',
        uid:'df#dju89JKL',
        appid:'df#dju89JKL',
        token:'df#dju89JKL',

      }
});
*/
export default Api;